import _defineProperty from "/workdir/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Container from "@scentregroup/ui/components/container";
import { Spotlight, SpotlightCard } from '../';
import { trackClickEvent } from './analytics';
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";

const SpotlightModule = ({
  moduleProps,
  useAlternateDesign
}) => /*#__PURE__*/_jsx(Container, {
  centred: true,
  type: "large",
  children: /*#__PURE__*/_jsx(Spotlight, _objectSpread(_objectSpread({
    heading: moduleProps.title,
    shortDescription: moduleProps.shortDescription,
    alternateDesign: useAlternateDesign
  }, moduleProps), {}, {
    children: (moduleProps.entries || []).map(entry => /*#__PURE__*/_createElement(SpotlightCard, _objectSpread(_objectSpread({}, entry), {}, {
      color: moduleProps.color,
      key: entry.id,
      alternateDesign: useAlternateDesign,
      onClick: () => trackClickEvent(entry.title, moduleProps.heading || moduleProps.title)
    })))
  }))
});

export default SpotlightModule;